import { createSelector } from 'reselect';
import { getTravelUgInsurance } from './index';
import { FORM_STATUS, API_CALL_STATUS } from '../../reducers/status';

export const getTravelDetails = createSelector(getTravelUgInsurance, (state) => state.travelDetails);

export const getTravelDetailsForm = createSelector(getTravelDetails, (travelDetails) => travelDetails.form);

export const getSelectedForm = createSelector(getTravelDetails, (travelDetails) => travelDetails.selectedForm);

export const getDropOffDetails = createSelector(getTravelDetails, (travelDetails) => travelDetails.dropOffDetails);

export const getTravelDetailsFormValid = createSelector(
    getTravelDetails,
    (travelDetails) => travelDetails.formStatus === FORM_STATUS.VALID
);

export const getIsApiPending = createSelector(
    getTravelDetails,
    (travelDetails) => travelDetails.formStatus === API_CALL_STATUS.PENDING
);

export const getBlacklisted = createSelector(
    getTravelDetails,
    (travelDetails) => travelDetails && travelDetails.blacklisted
);

export const getPreventUserProceed = createSelector(
    getTravelDetails,
    (travelDetails) => travelDetails && travelDetails.preventUserProceed
);

export const getTravelDetailsSubmitted = createSelector(
    getTravelDetails,
    (travelDetails) => travelDetails && travelDetails.travelDetailsSubmitted
);

export const getCustomer = createSelector(getTravelDetails, (travelDetails) => travelDetails && travelDetails.customer);

export const getTravellers = createSelector(getTravelDetails, (travelDetails) => travelDetails.travellers);
export const getCurrentTravellerIndex = createSelector(
    getTravelDetails,
    (travelDetails) => travelDetails.currentTravellerIndex
);
const makeGetFieldForm = (fieldId) => createSelector(getTravelDetailsForm, (form) => form[fieldId]);

export const getDOBValue = makeGetFieldForm('dob');
export const getFullNameValue = makeGetFieldForm('fullName');
export const getFirstNameValue = makeGetFieldForm('firstName');
export const getMiddleNameValue = makeGetFieldForm('middleName');
export const getLastNameValue = makeGetFieldForm('lastName');
export const getIdTypeValue = makeGetFieldForm('idType');
export const getTinNumberValue = makeGetFieldForm('tinNumber');
export const getEmailValue = makeGetFieldForm('email');
export const getIdNumberValue = makeGetFieldForm('idNumber');
export const getPhoneNumberValue = makeGetFieldForm('phoneNumber');
export const getTravellerIdValue = makeGetFieldForm('travellerId');
export const getNationalityTypeValue = makeGetFieldForm('nationalityType');
export const getPassportNumberValue = makeGetFieldForm('passportNumber');
export const getProfessionValue = makeGetFieldForm('profession');
export const getOfficeNumberValue = makeGetFieldForm('officeNumber');
export const getTownValue = makeGetFieldForm('town');
export const getPostalAddressValue = makeGetFieldForm('postalAddress');
export const getBankNameValue = makeGetFieldForm('bankName');
export const getBankHolderNameValue = makeGetFieldForm('bankHolderName');
export const getBankAccountNumberValue = makeGetFieldForm('bankAccountNumber');
export const getBankBranchValue = makeGetFieldForm('bankBranch');
export const getBankAccountCurrencyValue = makeGetFieldForm('bankAccountCurrency');
export const getPassportBiodataValue = makeGetFieldForm('passportBiodata');
export const getPassportDocumentIdValue = makeGetFieldForm('passportDocumentId');
export const getIdDocumentIdValue = makeGetFieldForm('idDocumentId');
export const getIdUploadValue = makeGetFieldForm('idUpload');
//emergency contact details selectors
export const getEmergencyContactFullNameValue = makeGetFieldForm('emergencyContactFullName');
export const getEmergencyContactEmailAddressValue = makeGetFieldForm('emergencyContactEmailAddress');
export const getEmergencyContactPhoneNumberValue = makeGetFieldForm('emergencyContactPhoneNumber');
//consent
export const getPersonalDataProcessingConsent = makeGetFieldForm('personalDataProcessingConsent');
export const getChildDataProcessingConsent = makeGetFieldForm('childDataProcessingConsent');
export const getMarketingUseConsent = makeGetFieldForm('marketingUseConsent');
